import React, { useState } from "react";
import { toast } from "react-toastify";
import { AdminService } from "../../../app/service/admin.service";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";

const CreateUpload = () => {
  const navigate = useNavigate();
  const pathName = window.location.pathname;
  console.log(pathName);

  const [file, setFile] = useState(null);

  const handleFileChange = (e: any) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please select an XLSX file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    AdminService.uploadXlsx(formData)
      .then((res) => {
        if (res.status === "Fail") {
          toast.error(res.error);
        } else {
          if (pathName === "/manager/createUpload") {
            navigate("/manager/uploadList");
            toast.success(res.message);
          } else {
            navigate("/admin/uploadList");
            toast.success(res.message);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Upload failed");
      });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
      </div>
      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>
        <div className="col-md-6 mt-5 mx-auto">
          <div className="card shadow p-4 text-center">
            <h3 className="mb-3">Upload XLSX File</h3>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Choose XLSX File</label>
                <input
                  type="file"
                  className="form-control w-50 mx-auto"
                  accept=".xlsx,.xls"
                  onChange={handleFileChange}
                />
              </div>

              <button type="submit" className="btn btn-primary w-50 mx-auto">
                Upload
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUpload;
